// document.addEventListener("DOMContentLoaded", function() {
//     // Generate a random number for purchase count
//     var randomCount = Math.floor(Math.random() * 41) + 10;
//     document.getElementById("purchase-count").innerText = randomCount;

//     // Select a random product name from the list
//     var productNames = document.querySelectorAll("#product-names .product-name");
//     if (productNames.length > 0) {
//         var randomIndex = Math.floor(Math.random() * productNames.length);
//         var randomProductName = productNames[randomIndex].innerText;
//         document.getElementById("product-name").innerText = randomProductName;
//     }
// });

// document.addEventListener("DOMContentLoaded", function() {
//     // Generate a random number for purchase count
//     var randomCount = Math.floor(Math.random() * 41) + 10;
//     document.getElementById("purchase-count").innerText = randomCount;

//     // Select a random product name from the list
//     var productNames = document.querySelectorAll("#product-names .product-name");
//     if (productNames.length > 0) {
//         var randomIndex = Math.floor(Math.random() * productNames.length);
//         var randomProductName = productNames[randomIndex].innerText;
//         document.getElementById("product-name").innerText = randomProductName;
//     }
// });

// document.addEventListener("DOMContentLoaded", function() {
//     // Generate a random number for purchase count
//     var randomCount = Math.floor(Math.random() * 41) + 10;
//     document.getElementById("purchase-count").innerText = randomCount;

//     // Select a random product name and link from the list
//     var productNames = document.querySelectorAll("#product-names .product-name");
//     if (productNames.length > 0) {
//         var randomIndex = Math.floor(Math.random() * productNames.length);
//         var randomProductName = productNames[randomIndex].innerText;
//         var randomProductUrl = productNames[randomIndex].getAttribute("data-url");

//         // Update the visible product name and link URL
//         document.getElementById("product-name").innerText = randomProductName;
//         document.getElementById("product-link").setAttribute("href", randomProductUrl);
//     }
// });


// document.addEventListener("DOMContentLoaded", function() {
//     // Array of fashion-related emojis
    
//   var emojis = ["👕", "👚", "👖", "🧥", "👗"];
    
//     // Generate a random emoji
//     var randomEmoji = emojis[Math.floor(Math.random() * emojis.length)];

//     // Generate a random number for purchase count
//     var randomCount = Math.floor(Math.random() * 41) + 10;
//     document.getElementById("purchase-count").innerText = randomCount;

//     // Select a random product name and link from the list
//     var productNames = document.querySelectorAll("#product-names .product-name");
//     if (productNames.length > 0) {
//         var randomIndex = Math.floor(Math.random() * productNames.length);
//         var randomProductName = productNames[randomIndex].innerText;
//         var randomProductUrl = productNames[randomIndex].getAttribute("data-url");

//         // Update the visible product name, link URL, and add the emoji
//         document.getElementById("product-name").innerText = `${randomEmoji} ${randomProductName}`;
//         document.getElementById("product-link").setAttribute("href", randomProductUrl);
//     }
// });

document.addEventListener("DOMContentLoaded", function() {
    // Array of clothing-specific emojis
    var emojis = ["👕", "👚", "👖", "🧥", "👗"];
    
    // Generate a random emoji and assign it to the emoji span
    var randomEmoji = emojis[Math.floor(Math.random() * emojis.length)];
    document.getElementById("product-emoji").innerText = randomEmoji;

    // Generate a random number for purchase count
    var randomCount = Math.floor(Math.random() * 41) + 10;
    document.getElementById("purchase-count").innerText = randomCount;

    // Select a random product name and link from the list
    var productNames = document.querySelectorAll("#product-names .product-name");
    if (productNames.length > 0) {
        var randomIndex = Math.floor(Math.random() * productNames.length);
        var randomProductName = productNames[randomIndex].innerText;
        var randomProductUrl = productNames[randomIndex].getAttribute("data-url");

        // Update the product name and link URL
        document.getElementById("product-name").innerText = randomProductName;
        document.getElementById("product-link").setAttribute("href", randomProductUrl);
    }
});


